import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PostAuditConfigGenerate } from 'domain/usecases/reports/post-audit-config-generate';
import { RemotePostAuditConfigGenerate } from 'data/usecases/reports/remote-post-audit-config-generate';

export const makeRemotePostAuditConfigGenerate = (): PostAuditConfigGenerate => {
  const auditConfigGenerateUrl = `/audit/config/generate`;

  return new RemotePostAuditConfigGenerate(makeApiUrl(auditConfigGenerateUrl), makeAuthorizeHttpClientDecorator());
};
